import { RouteKey, getRoute } from '@aboutyou/legacy-shared/src/localizedUrls'
import {
  fsS,
  fsXXS,
  fwBold,
  fwMediumBold,
} from '@aboutyou/legacy-shared/src/ui/constants/typography'
import { exists } from '@aboutyou/legacy-shared/src/utils/exists'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { useRouter } from 'helpers/navigation'
import { SectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import BrandPromotionTracker from 'helpers/tracking/trackerComponents/BrandPromotionTracker'
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { useService } from 'services/utils/context'
import { useLocaleStore } from 'store/context'
import styled from 'styled-components'
import { mediaMaxS } from 'uiComponents/constants/customMedia'

const Wrapper = styled.div`
  margin-left: 80px;
`

const Title = styled.div`
  font-size: ${fsS}px;
  ${fwBold};
  margin-bottom: 24px;
`

const List = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 280px;

  @media ${mediaMaxS} {
    flex-wrap: nowrap;
    overflow: hidden;
  }
`

const ListItem = styled.li`
  display: inline-block;
  font-size: ${fsXXS}px;
  padding: 0 20px;
  line-height: 28px;
  cursor: pointer;
  text-transform: uppercase;

  :hover {
    ${fwMediumBold}
  }
`

const ShowMoreLink = styled(Link)`
  font-size: ${fsXXS}px;
  ${fwMediumBold}
  margin-top: 30px;
  cursor: pointer;

  :hover {
    ${fwBold}
  }
`

const PREMIUM_CATEGORY_ID = 144187

const BrandList: FC<{ brandIds: string[] }> = ({ brandIds }) => {
  const { t } = useTranslation()
  const { navigateClient } = useRouter()
  const locale = useLocaleStore(store => store.locale)
  const service = useService()

  const brands = brandIds
    .map(brandId => service.brands.getByBrandId(brandId))
    .filter(exists)

  const brandsUrl = getRoute(RouteKey.Brands, locale)

  if (!brands || brands.length === 0) {
    return null
  }

  brands.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  })

  return (
    <SectionTrackingContextProvider>
      <Wrapper>
        <Title>{t('Weitere Marken')}</Title>
        <List>
          {brands.map(brand => {
            return (
              <BrandPromotionTracker key={brand.id} brand={brand}>
                <ListItem onClick={navigateClient(brand.url)}>
                  {brand.name}
                </ListItem>
              </BrandPromotionTracker>
            )
          })}
        </List>
        <ShowMoreLink
          to={`${brandsUrl}?category=${PREMIUM_CATEGORY_ID}&premium=true`}
        >
          {t('Alle anzeigen')}
        </ShowMoreLink>
      </Wrapper>
    </SectionTrackingContextProvider>
  )
}

export default BrandList
